import React from 'react';
import brokenBob from 'IMGS/broken-image.svg';

import refreshIcon from './refresh-icon.svg';

import './ErrorBoundaryView.css';

const ErrorBoundaryBackground = ({ children }) => {
  return <div class="ErrorBoundaryView">{children}</div>;
};

const getErrorMessage = errorName => {
  const isChunkLoadError = errorName === 'ChunkLoadError';
  const title = isChunkLoadError ? 'Good news, a new app version is available!' : 'Oops, there’s been a problem';
  const message = 'Please refresh your browser to reload.';
  const icon = isChunkLoadError ? refreshIcon : brokenBob;

  return { title, message, icon };
};

const ErrorBoundaryModal = ({ title, message, icon }) => {
  return (
    <div class="ErrorBoundaryView_modal">
      <img class="ErrorBoundaryView_image" alt="" src={icon} />
      <h2 class="ErrorBoundaryView_title">{title}</h2>
      <p class="ErrorBoundaryView_body">{message}</p>
    </div>
  );
};

class ErrorBoundaryView extends React.Component {
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  render() {
    const { error, hasError } = this.state;

    if (hasError && error != null) {
      return (
        <ErrorBoundaryBackground>
          <ErrorBoundaryModal {...getErrorMessage(error?.name)} />
        </ErrorBoundaryBackground>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundaryView;
